import type { ErrandDelegationOffer } from '@pigello/pigello-matrix';

/**
 * Orders delegation offers so that executors (purposePlanner falsy) come
 * before planners/handlers (purposePlanner true). The sort is stable, so the
 * incoming order (e.g. '-createdAt') is kept within each group.
 */
export function sortExecutorsFirst(
  offers: ErrandDelegationOffer[]
): ErrandDelegationOffer[] {
  return [...offers].sort(
    (a, b) => Number(!!a.purposePlanner) - Number(!!b.purposePlanner)
  );
}
